import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _class2, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ForwardFocusRef } from "abreact/incubator/ui/utils/FocusUtils";
import { AbMarkdownLexical } from "abreact/input/markdown/AbMarkdownLexical";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
/**
 * CellEditorWrapper shim component used when editing string values as AbInitioMarkdown.
 */
export let GenericGridMarkdownEditor = (_dec = action.bound, _dec2 = action.bound, observer(_class = (_class2 = class GenericGridMarkdownEditor extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "currentValue", _descriptor, this);
    _defineProperty(this, "focusRef", new ForwardFocusRef());
    this.onChangeMarkdown = this.onChangeMarkdown.bind(this);
    this.currentValue = props.initialValue;
    makeObservable(this);
  }
  componentDidMount() {
    this.focusRef.whenExistsTakeFocusOnce();
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "generic-grid-markdown-editor",
      onKeyDown: this.onKeyDown
    }, /*#__PURE__*/React.createElement(AbMarkdownLexical, {
      value: this.currentValue,
      forwardFocusRef: this.focusRef,
      floatingToolbar: true,
      onChange: this.onChangeMarkdown
    }));
  }
  onChangeMarkdown(newMarkdown) {
    this.currentValue = newMarkdown;
    this.props.onChange(newMarkdown);
  }
  onKeyDown(event) {
    if (event.key === KeyValue.ENTER) {
      // We need to allow the editor to use the Enter key as a newline,
      // otherwise the DataGrid code will interpret the key as an intent to accept the value and commit the edit
      event.preventDefault();
      event.stopPropagation();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "currentValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "onChangeMarkdown", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeMarkdown"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onKeyDown", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "onKeyDown"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=GenericGridMarkdownEditor.js.map
